// extracted by mini-css-extract-plugin
export default {"loading":"Product_loading__Z+7vy","vendorInfo":"Product_vendorInfo__-WQ6Q"};